import { render, staticRenderFns } from "./SkillPage.vue?vue&type=template&id=3a1e469f"
import script from "./SkillPage.vue?vue&type=script&lang=js"
export * from "./SkillPage.vue?vue&type=script&lang=js"
import style0 from "./SkillPage.vue?vue&type=style&index=0&id=3a1e469f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports